export default class LockedIntoOutpostCommand {
	static protocol = {}

	constructor() {}
}
